export default __webpack_public_path__ + "static/media/CV-Felipe-Brando-2021.0ac391f8.pdf";